import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";
import IndexLogin from './Index/login'
import IndexRecord from './Index/record'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Index',
        redirect: "/record/statistics",
        component: () => import("../views/Index.vue"),
        children: [...IndexRecord]
    },
    {
        path: "/login",
        meta: {
            title: "登录",
        },
        component: () => import("../views/login/Index.vue"),
        children: [...IndexLogin],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
let originPush = VueRouter.prototype.push;  //备份原push方法

VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originPush.call(this, location, onResolve, onReject)
    return originPush.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
    // 记录上一页
    if (from) {
        store.commit("setPrePage", from.path);
    }
    let tokenKey = "index-token",
        toLogin = "/login";
    let token = localStorage.getItem(tokenKey);
    let nextUrl = false;

    if (to.meta.authorization && to.meta.authorization === true) {
        store.commit("setPrePage", to.path);
        if (!token) {
            nextUrl = toLogin;
        }
    } else {
        if (to.path === toLogin && token) {
            nextUrl = "/";
        }
    }
    document.title = to.meta.title;
    return nextUrl ? next(nextUrl) : next();
});

// 页面跳转之后页面回滚到顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
});
export default router
